module.exports = __webpack_public_path__ + "media/images/xpass/markers/inactive/stride-ab19be4023622292853cb13cc1a35567.png";